<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="hd-toggle-row">
    <v-switch
      v-model="model.value"
      :label="model.text"
      :disabled="isDisabled"
      dense
      class="hd-checkbox"
    >
    </v-switch>
    <v-icon
      v-if="model.isRestrictedByPermission"
      small
      class="restriction-icon"
      title="User with insufficient permissions"
    >
      mdi-information
    </v-icon>
  </div>
</template>
<script>
import { ComponentModel } from '../../../model/ComponentModel'

export default {
  name: 'HdToggleField',
  props: {
    model: {
      type: ComponentModel,
      required: false,
      default() {
        return new ComponentModel()
      },
    },
  },

  computed: {
    isDisabled() {
      return Boolean(this.model.readOnly || this.model.isRestrictedByPermission)
    },
  },

  watch: {
    'model.value': function () {
      this.$emit('valuechange', this.model)
    },
  },
}
</script>

<style scoped>
.hd-toggle-row {
  display: flex;
  align-items: center;
}

.hd-checkbox {
  padding-top: 0;
  color: #fff;
  margin-top: 0;
  flex-grow: 0;
}

.restriction-icon {
  color: #ff9800;
  flex-shrink: 0;
  margin-left: 4px;
  margin-bottom: 18px;
}
</style>
